import { createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SurveyTemplate } from "../../../models/SurveyTemplates";
import { LoadableContext } from "../../store";

const surveyTemplatesAdapter = createEntityAdapter<SurveyTemplate>({
    selectId: template => template.ID,
    sortComparer: (template1, template2) => {
        return template1.name.localeCompare(template2.name);
    }
});

interface SurveyTemplatesState extends LoadableContext {}

const initialState: SurveyTemplatesState = {
    loading: false,
    error: null,
};

export const surveyTemplatesSlice = createSlice({
    name: 'survey_templates_list',
    initialState: surveyTemplatesAdapter.getInitialState(initialState),
    reducers: {
        startLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        stopLoading: (state) => {
            state.loading = false;
        },
        setList: (state, { payload: templates }: PayloadAction<SurveyTemplate[]>) => {
            state.loading = false;
            surveyTemplatesAdapter.setAll(state, templates);
        },
        addTemplate: (state, { payload: template }: PayloadAction<SurveyTemplate>) => {
            state.loading = false;
            surveyTemplatesAdapter.addOne(state, template);
        },
        updateTemplate: (state, { payload: { id, changes } }: PayloadAction<{ id: string, changes: Partial<SurveyTemplate> }>) => {
            surveyTemplatesAdapter.updateOne(state, {
                id,
                changes,
            });
        },
        removeTemplate: (state, { payload: templateId }: PayloadAction<string>) => {
            surveyTemplatesAdapter.removeOne(state, templateId);
        },
        setError: (state, { payload }: PayloadAction<string>) => {
            state.loading = false;
            state.error = payload;
        },
    },
});

export const SurveyTemplatesActions = surveyTemplatesSlice.actions;
export const { selectAll: selectAllSurveyTemplates, selectById: selectSurveyTemplateById } = surveyTemplatesAdapter.getSelectors();
export default surveyTemplatesSlice.reducer;
